import React from 'react';

import { Collapse } from 'antd';

type Props = {
  className?: string;
  children?: React.ReactNode;
  label?: string;
};

const Collapsed = ({ className, children, label }: Props) => (
  <Collapse
    className={className}
    style={{ marginBottom: 10 }}
    size="small"
    items={[{
      key: label,
      label,
      children
    }]}
  />
);

export default Collapsed;
